export default "__VITE_ASSET__Dn5z$HDX__"